import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import styled from 'styled-components';



import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from "@mui/material/styles";
import theme from "../style/theme.js";


/** Composants */
import Logo from '../components/Logo.js'
import NavBar from '../components/NavBar.js'
import Footer from '../components/Footer.js'
import ElementAssociation from '../components/ElementAssociation.js'

/** Api */
import { apiListe } from '../api.js';

const Page = styled.div`
position:relative;
min-height:100vh;
padding-bottom:300px;
`
const Titre = styled.h2`
margin:0 auto;
`
const PageAssociation = () => {
    const {typeElement, id, typeElementAAssocier} = useParams()

    const [liste, setListe] = useState([])
    const [loading, setLoading] = useState(true)
    const [erreur, setErreur] = useState(false)

    useEffect(() => {
        apiListe(typeElementAAssocier, '*')
        .then(res => {
            setListe(res.reponse)
            console.log("Liste des '" + typeElementAAssocier + "'" )
            console.log(res.reponse)
            setLoading(false)
        })
        .catch(error => {
            console.log(error)
            setLoading(false)
            setErreur(true)
        })
    }, [typeElementAAssocier])

    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Titre>Association {typeElement} avec {typeElementAAssocier} </Titre>
            { !loading  && !erreur && liste
            && <ElementAssociation
                key={id}
                id={id}
                typeElement={typeElement}
                typeElementAAssocier={typeElementAAssocier}
                liste={liste}/>}
            {loading  && <ThemeProvider  theme={theme}><CircularProgress color="secondary"/><h3>Je charge</h3></ThemeProvider> }
            {erreur  && <h3>J'ai rencontré un problème...</h3> }
            <Footer/>
        </Page>
    )
}
export default PageAssociation